/* eslint-disable react/jsx-filename-extension */
// This file is for helpers that relate to any helper function within the application
import React from 'react';
import * as R from 'ramda';
import { Box, Button } from '@mui/material';

export const findOptionByValue = (value, options) => R.find(R.propEq('value', value), options);
export const createSnackButtons = buttons => (
  <Box color="background.paper">
    {buttons.map(({ label, onClick }) => (
      <Button
        color="inherit"
        key={label}
        onClick={() => {
          onClick();
        }}
        size="small"
        sx={{
          '&:hover': {
            color: 'text.primary',
          },
          fontFamily: 'Gothic A1',
          fontSize: 14,
        }}
        variant="text"
      >
        {label}
      </Button>
    ))}
  </Box>
);
